import { IEntertainmentEventBooking } from '@shared/shared/interfaces/entertainment-event.interfaces';
import * as entertainmentEventBookingActions from '../actions/entertainment-event-booking.actions';

export interface EntertainmentEventBookingState extends IEntertainmentEventBooking {
  loading: boolean;
  loaded: boolean;
  viewed: boolean;
}

export const initialState: EntertainmentEventBookingState = {
  id: 0,
  delivery_method: '',
  available_delivery_methods: [],
  confirmed_terms: false,
  is_complete: false,
  payment_card: '',
  payment_redirect_url: '',
  provider: '',
  performance: null,
  date: '',
  venue_name: '',
  save_card: false,
  use_saved_card: false,
  tickets: [],
  was_successful: null,
  total_amount: 0,
  total_amount_currency: '',
  loading: false,
  loaded: false,
  viewed: false,
  booking_hero_image: {
    image: '',
    cover: false,
    type: 'entertainment',
  },
};

export function reducer(
  state = initialState,
  action: entertainmentEventBookingActions.EntertainmentEventBookingAction
): EntertainmentEventBookingState {
  switch (action.type) {
    case entertainmentEventBookingActions.CREATE_BOOKING: {
      return {
        ...state,
        ...action.payload,
        loading: true,
        loaded: false,
        was_successful: null,
      };
    }

    case entertainmentEventBookingActions.CREATE_BOOKING_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        viewed: false,
        loaded: true,
        loading: false,
      };
    }

    case entertainmentEventBookingActions.CREATE_BOOKING_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
        was_successful: false,
      };
    }

    case entertainmentEventBookingActions.UPDATE_BOOKING: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }

    case entertainmentEventBookingActions.UPDATE_BOOKING_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        loaded: true,
        loading: false,
      };
    }

    case entertainmentEventBookingActions.UPDATE_BOOKING_FAIL: {
      return {
        ...state,
        loaded: false,
        loading: false,
      };
    }

    case entertainmentEventBookingActions.VIEW_BOOKING: {
      return {
        ...state,
        loading: true,
      };
    }

    case entertainmentEventBookingActions.VIEW_BOOKING_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        viewed: true,
        loading: false,
        loaded: true,
      };
    }

    case entertainmentEventBookingActions.VEIW_BOOKING_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }

    case entertainmentEventBookingActions.RESET_BOOKING: {
      return {
        ...initialState,
      };
    }

    case entertainmentEventBookingActions.UPDATE_BOOKING_ORDER_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        is_complete: true,
        was_successful:
          (action.payload.payment_status === 'done' ||
            action.payload.payment_status === 'authorized' ||
            action.payload.payment_status === 'authorised') &&
          action.payload.status === 'booked',
      };
    }

    case entertainmentEventBookingActions.UPDATE_BOOKING_ORDER_FAIL: {
      return {
        ...state,
        is_complete: true,
        was_successful: false,
      };
    }
    default:
      return state;
  }
}

export const getWasSuccessful = (state: EntertainmentEventBookingState) => state.was_successful;
